// Show more document functions
var moreButton = document.querySelector('.documents .read-more')
var openDoc = document.querySelector('.documents .content')
var lessButton = document.querySelector('.documents .read-less')
var documentLinks = document.querySelectorAll('.documents .document-link')

console.log (documentLinks.length)

if (moreButton){
  if (documentLinks.length < 3) {
      openDoc.classList.toggle('open')
      moreButton.classList.toggle('hide')  
  }
}

if (moreButton){
  moreButton.addEventListener('click', function() {
    openDoc.classList.toggle('open')
    lessButton.classList.toggle('show')  
    moreButton.classList.toggle('hide')  
  });

  lessButton.addEventListener('click', function() {
    openDoc.classList.toggle('open')
    lessButton.classList.toggle('show')  
    moreButton.classList.toggle('hide')  
  });
}
